import Box from "@material-ui/core/Box";
import { getMaxSsccLabelId } from "entities/InternalPalletLabels";
import React from "react";
import { Edit, SimpleForm, useTranslate } from "react-admin";
import { useFormState } from "react-final-form";

import { FormGroupGrid, GridForm, GridInput } from "../../../components/GridForm";
import { GS1CompanyPrefixInput } from "../../../components/inputs/GS1CompanyPrefixInput";
import { SaveWithCancelToolbar } from "../../../components/toolbars/SaveWithCancelToolbar";
import { PrintInternalPalletLabels } from "./components/PrintInternalPalletLabels";
import { TerminalLabelLogo } from "./components/TerminalLabelLogo";
import { useTerminalLabelLogo } from "./components/useTerminalLabelLogo";

const SECTION_SPACING = 1;

const TerminalGS1CompanyPrefixInput = (props) => {
	const translate = useTranslate();
	const { values } = useFormState({ subscription: { values: true } });
	const maxSsccLabelId = getMaxSsccLabelId(values.gs1_company_prefix);

	return (
		<GS1CompanyPrefixInput
			{...props}
			helperText={
				maxSsccLabelId === null
					? undefined
					: translate("resources.terminal.internal-pallet-labels.max_sscc_label_id_hint", {
							max_sscc_label_id: maxSsccLabelId.toLocaleString(),
					  })
			}
		/>
	);
};

const InternalPalletLabelsSettingsForm = (props) => {
	const translate = useTranslate();
	return (
		<GridForm {...props}>
			<FormGroupGrid title={translate("resources.terminal.internal-pallet-labels.settings_section")}>
				<GridInput sm={3} component={TerminalGS1CompanyPrefixInput} source="gs1_company_prefix" />
			</FormGroupGrid>
		</GridForm>
	);
};

export const InternalPalletLabelsTab = ({ canEditLabelSettings, ...props }) => {
	const { labelLogo, setLabelLogo, isLoading } = useTerminalLabelLogo(props.id);

	return (
		<>
			<Edit {...props} undoable={false}>
				<SimpleForm
					submitOnEnter={false}
					toolbar={canEditLabelSettings ? <SaveWithCancelToolbar /> : false}
				>
					<InternalPalletLabelsSettingsForm disabled={!canEditLabelSettings} />
				</SimpleForm>
			</Edit>
			<Box marginTop={SECTION_SPACING}>
				<TerminalLabelLogo
					terminalId={props.id}
					labelLogo={labelLogo}
					isLoading={isLoading}
					onLabelLogoChange={setLabelLogo}
					canEdit={canEditLabelSettings}
				/>
			</Box>
			<Box marginTop={SECTION_SPACING}>
				<PrintInternalPalletLabels
					terminalId={props.id}
					hasLabelLogo={Boolean(labelLogo?.filename)}
				/>
			</Box>
		</>
	);
};
